/**
 * Authentication utilities using Clerk
 * This file provides auth helpers and exports for use throughout the app
 */

import { useAuth as useClerkAuth, useUser as useClerkUser } from '@clerk/clerk-react'

// Re-export Clerk hooks with consistent naming
export const useAuth = useClerkAuth
export const useUser = useClerkUser

// Export commonly used Clerk components
export {
  SignIn,
  SignUp,
  SignInButton,
  SignUpButton,
  SignOutButton,
  UserButton,
  UserProfile,
  OrganizationSwitcher,
  OrganizationProfile,
  CreateOrganization
} from '@clerk/clerk-react'

// Helper function for handling auth errors  
export function handleAuthError(error: any) {
  console.error('Auth error:', error)
  if (error?.message) {
    throw new Error(error.message)
  }
  throw new Error('Authentication failed')
}

// Helper to check if user has a specific role (for future use)
export function useHasRole(role: string) {
  const { user } = useClerkUser()
  return user?.publicMetadata?.role === role
}

// Helper to get user's organizations
export function useUserOrganizations() {
  const { user } = useClerkUser()
  return user?.organizationMemberships || []
}